import React from 'react'
import "./AdItem.css"

const AdItem = (props) => {
  const serverPublic = process.env.REACT_APP_PUBLIC_FOLDER;
  return (
    <div className='Ad-card'>

      <div className='Ad-img-container'>
        <img src={props.img} alt="" className='Ad-img' />
      </div>

      <div className='Ad-details'>
        <p>{props.category}</p>
        <h4>{props.name}</h4>
        <p>By - {props.author}</p>
        <b><p><i className="fa-solid fa-indian-rupee-sign"></i> {props.price} {props.sold ? "(SOLD)":""} </p></b>
      </div>

    </div>

  )
}

export default AdItem